import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Button from '@/components/Button';
import { PageHeading, TeamHeading } from '@/components/Layout/Parts';
import { RootState } from '@/utils/store';

import GroupsTable from './GroupsTable';
import ReportsGroupForm from './ReportsGroupForm';

const HeadingRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 26px;
`;

const StyledPageHeading = styled(PageHeading)`
  margin: 0;
`;

const Reports = () => {
  const [showFormDialog, setShowFormDialog] = useState(false);

  const userRole = useSelector(
    (state: RootState) => state.auth.user!.role.name,
  );

  return (
    <>
      <TeamHeading />
      <HeadingRow>
        <StyledPageHeading>Other Reports</StyledPageHeading>
        <Button onClick={() => setShowFormDialog(true)}>New Group</Button>
      </HeadingRow>
      <GroupsTable userRole={userRole} />
      <AnimatePresence>
        {showFormDialog && (
          <ReportsGroupForm onClose={() => setShowFormDialog(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default Reports;
